<template>
    <div class="link-page">
        <h1>Privacy policy</h1>
        <router-link to="/" tag="button">Back</router-link>
    </div>
</template>

<script>
export default {
    name: 'Privacy'
};
</script>

<style lang="scss">
.link-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    flex: 1 1 auto;

    button {
        margin-bottom: 1em;
        font-size: x-large;
    }
}
</style>
